import { Download, Info, RotateCcw } from "lucide-react";
import { useState, useEffect, useContext } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import { useRef } from "react";
import axios from "axios";
import { BASE_URL } from "../../../config/api";
import RegularLoader from "../../../Component/Loader/RegularLoader";
import { AuthContext } from "../../../context/AuthContext";
import RefreshButton from "../../../Component/Common/RefreshButton";
import React from "react";
import toast from "react-hot-toast";
import { cn } from "./Invoice/invoiceUtils";

export default function ModelPriceList() {

  const { user } = useContext(AuthContext);
  const company_id =
    user?.role === 2
      ? user?.id           // 🔥 For role 2 use session id
      : user?.company_id;  // ✅ For other roles use company_id

  const isRetailerMobile =
    typeof window !== "undefined" &&
    window.innerWidth < 640 &&
    user?.role === 5;
      
  const [activeTooltip, setActiveTooltip] = useState(null);
  const tableRef = useRef();

  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [productTypes, setProductTypes] = useState([]);

  const [categories, setCategories] = useState([]);
  const [selectedBrandId, setSelectedBrandId] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  const sectionColors = [
  {
    header: "bg-blue-100",
    cell: "bg-blue-100",
    text: "text-blue-700",
    badgeBorder: "border-blue-600",
    badgeText: "text-blue-700",
  },
  {
    header: "bg-violet-100",
    cell: "bg-violet-100",
    text: "text-violet-700",
    badgeBorder: "border-violet-600",
    badgeText: "text-violet-700",
  },
  {
    header: "bg-amber-100",
    cell: "bg-amber-100",
    text: "text-amber-700",
    badgeBorder: "border-amber-600",
    badgeText: "text-amber-700",
  },
  {
    header: "bg-emerald-100",
    cell: "bg-emerald-100",
    text: "text-emerald-700",
    badgeBorder: "border-emerald-600",
    badgeText: "text-emerald-700",
  },
];

  useEffect(() => {
  const close = () => setActiveTooltip(null);
  window.addEventListener("click", close);
  return () => window.removeEventListener("click", close);
}, []);

const handleResetFilters = () => {
  setSelectedBrand("");
  setSearch("");
};

  // const models = [
  //   {
  //     model: "Vivo V50",
  //     devicePrice: 45000,

  //     screen545: { price: 500, name: "Screen Protect 545", sublabel: "545 Days", desc: "1 accidental screen claim for 545 days." },
  //     screen730: { price: 900, name: "Screen Protect 730", sublabel: "730 Days", desc: "2 accidental screen claims for 730 days." },

  //     total545: { price: 1500, name: "Total Protect 545", sublabel: "Up to Device Price", desc: "Covers screen + hardware up to device value." },
  //     total730: { price: 2000, name: "Total Protect 730", sublabel: "Up to Device Price", desc: "Extended total coverage for 730 days." },

  //     extended545: { price: 1200, name: "Extended 545", sublabel: "100% Coverage", desc: "Manufacturing defect coverage for 545 days." },
  //     extended730: { price: 1700, name: "Extended 730", sublabel: "100% Coverage", desc: "Extended hardware protection for 730 days." },
  //   },
  //   {
  //     model: "Samsung A54",
  //     devicePrice: 38000,

  //     screen545: { price: 450, name: "Screen Protect 545", sublabel: "1 Claim", desc: "1 accidental screen claim for 545 days." },
  //     screen730: { price: 850, name: "Screen Protect 730", sublabel: "3 Claim", desc: "2 accidental screen claims for 730 days." },

  //     total545: { price: 1400, name: "Total Protect 545", sublabel: "Up to Device Price", desc: "Covers screen + hardware up to device value." },
  //     total730: { price: 1900, name: "Total Protect 730", sublabel: "Up to Device Price", desc: "Extended total coverage for 730 days." },

  //     extended545: { price: 1100, name: "Extended 545", sublabel: "100% Coverage", desc: "Manufacturing defect coverage for 545 days." },
  //     extended730: { price: 1600, name: "Extended 730", sublabel: "100% Coverage", desc: "Extended hardware protection for 730 days." },
  //   }
  // ];

 
  const fetchPriceReport = async () => {
  try {
    setLoading(true);

    const params = new URLSearchParams({
      company_id,
    });

    if (selectedBrandId) {
      params.append("brand_id", selectedBrandId);
    }

    if (selectedCategoryId) {
      params.append("category_id", selectedCategoryId);
    }

    const response = await axios.get(
      `${BASE_URL}warranty/price-report?${params.toString()}`
    );

    if (response.data.success) {
      const transformed = transformApiData(response.data.data);
      setModels(transformed);
    }

  } catch (error) {
    console.error("Price Report API Error:", error);
  } finally {
    setLoading(false);
  }
};

 useEffect(() => {
  fetchPriceReport();
}, [selectedBrandId, selectedCategoryId]);

useEffect(() => {
  const fetchBrands = async () => {
    try {
      const res = await axios.get(`${BASE_URL}warranty/get-brands`);
      if (res.data?.data) {
        setBrands(res.data.data);
      }
    } catch (err) {
      console.error("Brand API Error:", err);
    }
  };

  fetchBrands();
}, []);

useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${BASE_URL}warranty/get-categories`);

      if (res.data) {
        // ✅ Only active categories
        const activeCategories = res.data.filter(
          (cat) => cat.status === 1
        );

        setCategories(activeCategories);
      }
    } catch (err) {
      console.error("Category API Error:", err);
    }
  };

  fetchCategories();
}, []);

const transformApiData = (apiArray) => {
  const typeSet = new Set();

  apiArray.forEach((item) => {
    (item.packages || []).forEach((p) => {
      if (p.product_type) typeSet.add(p.product_type);
    });
  });

  const allTypes = [...typeSet];
  setProductTypes(allTypes);

  const transformed = apiArray.map((item) => {
    const packages = item.packages || [];

    const dynamicPlans = {};

    allTypes.forEach((type) => {
      const plans = packages
        .filter((p) => p.product_type === type)
        .sort((a, b) => (a.validity_days || 0) - (b.validity_days || 0))
        .map((plan) => ({
          price: plan?.product_price
            ? Number(plan.product_price)
            : "-",
          name: plan?.product_name || "-",
          sublabel: plan?.claims
            ? `${plan.claims} Claims`
            : "-",
          desc: plan?.product_name || "-",
          profit: plan?.retailer_payout
            ? Number(plan.retailer_payout)
            : "-",
          validity: plan?.validity_days || null,
        }));

      dynamicPlans[type] = plans;
    });

    return {
      model: item.model,
      brand: item.brand,
      devicePrice: Number(item.device_price),
      ...dynamicPlans,
    };
  });

  return transformed;
};

  /* ================= SEARCH ================= */
  const [search, setSearch] = useState("");

  // const filteredModels = models.filter((item) => {
  //   const matchesSearch = item.model
  //     .toLowerCase()
  //     .includes(search.toLowerCase());

  //   const matchesBrand = selectedBrand
  //     ? item.model.toLowerCase().includes(selectedBrand.toLowerCase())
  //     : true;

  //   return matchesSearch && matchesBrand;
  // });

  const filteredModels = models.filter((item) => {

  const matchesSearch =
    item.model?.toLowerCase().includes(search.toLowerCase()) ||
    item.brand?.toLowerCase().includes(search.toLowerCase());

  const hasValidPlan = productTypes.some((type) => {
    const plans = item[type] || [];

    return plans.some(
      (plan) =>
        plan.price !== "-" &&
        plan.price !== null &&
        plan.price !== undefined
    );
  });

  return matchesSearch && hasValidPlan;
});

  const getMaxPlans = () => {
  let max = 0;

  models.forEach((model) => {
    productTypes.forEach((type) => {
      const count = model[type]?.length || 0;
      if (count > max) max = count;
    });
  });

  return max;
};

const maxPlans = getMaxPlans();


const getValidityMap = () => {
  const map = {};

  models.forEach((model) => {
    productTypes.forEach((type) => {
      const plans = model[type] || [];

      plans.forEach((plan) => {
        if (!map[type]) map[type] = new Set();
        if (plan.validity) {
          map[type].add(plan.validity);
        }
      });
    });
  });

  // convert Set to sorted array
  const result = {};
  Object.keys(map).forEach((type) => {
    result[type] = Array.from(map[type]).sort((a, b) => a - b);
  });

  return result;
};

const validityMap = getValidityMap();

const totalColumns = productTypes.reduce(
  (sum, type) => sum + (validityMap[type]?.length || 1),
  0
);

const gridTemplate = `
  minmax(150px, 220px)
  repeat(${totalColumns}, minmax(140px, 1fr))
`;



 // Proper Base64 converter (NO spacing issue)
  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;

    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
  };

  const loadFont = async (pdf) => {

    /* ========= LOAD REGULAR ========= */

    const regularResponse = await fetch("/fonts/NotoSans-Regular.ttf");
    const regularBuffer = await regularResponse.arrayBuffer();
    const base64Regular = arrayBufferToBase64(regularBuffer);

    pdf.addFileToVFS("NotoSans-Regular.ttf", base64Regular);
    pdf.addFont("NotoSans-Regular.ttf", "NotoSans", "normal");


    /* ========= LOAD BOLD ========= */

    const boldResponse = await fetch("/fonts/NotoSans-Bold.ttf");
    const boldBuffer = await boldResponse.arrayBuffer();
    const base64Bold = arrayBufferToBase64(boldBuffer);

    pdf.addFileToVFS("NotoSans-Bold.ttf", base64Bold);
    pdf.addFont("NotoSans-Bold.ttf", "NotoSans", "bold");


    /* ========= SET DEFAULT ========= */

    pdf.setFont("NotoSans", "normal");
  };

  const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};


  const handleDownload = async () => {
  try {
    /* ================= 1. FILTER MODELS WITH NO DATA ================= */
    // Only include models that have at least one valid plan across all product types
    const modelsWithData = filteredModels.filter((item) => {
      return productTypes.some((type) => {
        const plans = item[type] || [];
        // Check if any plan in this type has a valid price
        return plans.some((plan) => plan.price && plan.price !== "-");
      });
    });

    if (!productTypes?.length || !modelsWithData?.length) {
      toast.error("No product data found for these filters");
      return;
    }

    toast.loading("Generating PDF...");
    await new Promise((r) => setTimeout(r, 50));

    const pdf = new jsPDF("l", "mm", "a4");
    await loadFont(pdf);
    const logoBase64 = await getBase64FromUrl("/icons/goelectronix-logo.png");

    /* ================= 2. DYNAMIC COLORS & WIDTHS ================= */
    const sectionColorsPdf = {
      "Screen Damage": { bg: [191, 219, 254], border: [37, 99, 235] },
      "Total Protection": { bg: [221, 214, 254], border: [124, 58, 237] },
      "Extended Warranty": { bg: [254, 243, 199], border: [234, 88, 12] },
    };

    const totalPlanColumns = productTypes.reduce((sum, type) => {
      return sum + (validityMap[type]?.length || 1);
    }, 0);
    
    const totalColumns = 1 + totalPlanColumns;
    const equalWidth = 277 / totalColumns;

    /* ================= 3. HEADERS ================= */
    const headRow1 = [
      {
        content: "Models",
        rowSpan: 2,
        styles: { fillColor: false, textColor: [0, 0, 0], fontSize: 10, fontStyle: 'bold', halign: 'center', valign: 'middle' },
      },
    ];
    const headRow2 = [];

    productTypes.forEach((type) => {
      const columnCount = validityMap[type]?.length || 1;
      const bgColor = sectionColorsPdf[type]?.bg || [240, 240, 240];
      headRow1.push({
        content: type,
        colSpan: columnCount,
        styles: { fillColor: bgColor, textColor: [0, 0, 0], fontSize: 10, halign: 'center' },
      });

      if (validityMap[type]?.length > 0) {
        validityMap[type].forEach(() => {
          headRow2.push({ content: "", styles: { fillColor: bgColor } });
        });
      } else {
        headRow2.push({ content: "-", styles: { fillColor: bgColor } });
      }
    });

    const head = [headRow1, headRow2];

    /* ================= 4. BODY DATA MAPPING ================= */
    const cellDataMap = {};
    // 🔥 Use modelsWithData instead of filteredModels
    const body = modelsWithData.map((item, rowIndex) => {
      const row = [""]; 
      productTypes.forEach((type) => {
        if (validityMap[type]?.length > 0) {
          validityMap[type].forEach((days) => {
            const plan = (item[type] || []).find((p) => p.validity === days);
            const key = `${rowIndex}-${type}-${days}`;
            if (plan && plan.price !== "-") {
              cellDataMap[key] = plan;
              row.push(""); 
            } else {
              row.push("-");
            }
          });
        } else {
          row.push("-");
        }
      });
      return row;
    });

    /* ================= 5. TABLE GENERATION ================= */
    autoTable(pdf, {
      head,
      body,
      theme: "grid",
      margin: { top: 40, bottom: 20 },
      styles: {
        font: "NotoSans",
        fontSize: 8,
        cellPadding: 4,
        valign: "top",
        lineColor: [230, 230, 230],
        lineWidth: 0.3,
        cellWidth: equalWidth,
      },
      
      didParseCell: function (data) {
        if (data.section === "body" && data.column.index !== 0) {
          let cumulative = 0;
          let selectedType = null;
          for (let i = 0; i < productTypes.length; i++) {
            const count = validityMap[productTypes[i]]?.length || 1;
            if (data.column.index - 1 < cumulative + count) {
              selectedType = productTypes[i];
              break;
            }
            cumulative += count;
          }
          data.cell.styles.fillColor = sectionColorsPdf[selectedType]?.bg || [255, 255, 255];
          data.row.height = 42;
        }
      },

      didDrawCell: function (data) {
        const cx = data.cell.x + data.cell.width / 2;

        /* MODEL COLUMN (using modelsWithData) */
        if (data.section === "body" && data.column.index === 0) {
          const item = modelsWithData[data.row.index]; // 🔥 Use modelsWithData
          if (!item) return;

          const x = data.cell.x + 4;
          let y = data.cell.y + 8;

          pdf.setFont("NotoSans", "bold");
          pdf.setFontSize(10);
          pdf.setTextColor(0, 0, 0);
          const wrappedModel = pdf.splitTextToSize(item.model || "", data.cell.width - 8);
          pdf.text(wrappedModel, x, y);
          
          y += (wrappedModel.length * 4.5) + 1;

          pdf.setFontSize(9);
          pdf.setTextColor(37, 99, 235);
          pdf.text(item.brand || "", x, y);

          y += 5;

          pdf.setFont("NotoSans", "normal");
          pdf.setFontSize(8);
          pdf.setTextColor(120, 120, 120);
          pdf.text(`₹${item.devicePrice?.toLocaleString() || "0"}`, x, y);
        }

        /* HEADER BADGES (Days) */
        if (data.section === "head" && data.row.index === 1) {
          const colIndex = data.column.index;
          if (colIndex === 0) return;

          let cumulative = 0;
          let selectedType = null;
          let dayValue = null;

          for (let i = 0; i < productTypes.length; i++) {
            const count = validityMap[productTypes[i]]?.length || 1;
            if (colIndex - 1 < cumulative + count) {
              selectedType = productTypes[i];
              dayValue = validityMap[productTypes[i]]?.[colIndex - 1 - cumulative];
              break;
            }
            cumulative += count;
          }

          if (!dayValue) return;

          const colorCfg = sectionColorsPdf[selectedType] || { border: [16, 185, 129] };
          const badgeW = Math.min(data.cell.width * 0.8, 24);
          const badgeH = 7;
          const bx = data.cell.x + (data.cell.width - badgeW) / 2;
          const by = data.cell.y + (data.cell.height - badgeH) / 2;

          pdf.setFillColor(255, 255, 255);
          pdf.setDrawColor(...colorCfg.border);
          pdf.setLineWidth(0.5);
          pdf.roundedRect(bx, by, badgeW, badgeH, 3, 3, "FD");

          pdf.setFontSize(7);
          pdf.setTextColor(...colorCfg.border);
          pdf.text(`${dayValue} Days`, cx, by + 4.8, { align: "center" });
        }

        /* BODY PLAN DETAILS */
        if (data.section === "body" && data.column.index !== 0) {
          const rowIndex = data.row.index;
          const colIndex = data.column.index;
          let cumulative = 0;
          let selectedType = null;
          let dayValue = null;

          for (let i = 0; i < productTypes.length; i++) {
            const count = validityMap[productTypes[i]]?.length || 1;
            if (colIndex - 1 < cumulative + count) {
              selectedType = productTypes[i];
              dayValue = validityMap[productTypes[i]]?.[colIndex - 1 - cumulative];
              break;
            }
            cumulative += count;
          }

          const key = `${rowIndex}-${selectedType}-${dayValue}`;
          const plan = cellDataMap[key];
          if (!plan) return;

          let cy = data.cell.y + 7;
          pdf.setFont("NotoSans", "bold");
          pdf.setFontSize(11);
          pdf.setTextColor(180, 83, 9);
          pdf.text(`₹${plan.price}`, cx, cy, { align: "center" });

          cy += 4;
          const profitTxt = `Profit ₹${plan.profit}`;
          pdf.setFontSize(8);
          const tw = pdf.getTextWidth(profitTxt);
          pdf.setFillColor(16, 185, 129);
          pdf.roundedRect(cx - (tw + 6) / 2, cy, tw + 6, 5.5, 2, 2, "F");
          pdf.setTextColor(255);
          pdf.text(profitTxt, cx, cy + 4, { align: "center" });

          cy += 11;
          pdf.setFont("NotoSans", "bold");
          pdf.setFontSize(8.5);
          pdf.setTextColor(16, 185, 129);
          pdf.text(plan.sublabel || "", cx, cy, { align: "center" });

          cy += 4;
          pdf.setFont("NotoSans", "normal");
          pdf.setFontSize(7);
          pdf.setTextColor(80, 80, 80);
          const wrappedName = pdf.splitTextToSize(plan.name || "", data.cell.width - 6);
          pdf.text(wrappedName, cx, cy, { align: "center" });
        }
      },

      didDrawPage: function (data) {
        const pageHeight = pdf.internal.pageSize.getHeight();
        const pageWidth = pdf.internal.pageSize.getWidth();
        pdf.saveGraphicsState();
        pdf.setGState(new pdf.GState({ opacity: 0.06 }));
        pdf.setFont("NotoSans", "bold");
        pdf.setFontSize(60);
        pdf.setTextColor(150);
        pdf.text("Warranty Mitra", pageWidth / 2, pageHeight / 2, { align: "center", angle: 45 });
        pdf.restoreGraphicsState();
        if (logoBase64) pdf.addImage(logoBase64, "PNG", 14, 6, 25, 25);
        pdf.setFont("NotoSans", "bold");
        pdf.setFontSize(18);
        pdf.setTextColor(0, 51, 102);
        pdf.text("Warranty Mitra", 45, 16);
        pdf.setFont("NotoSans", "normal");
        pdf.setFontSize(11);
        pdf.setTextColor(100);
        pdf.text("Model Wise Price List", 45, 23);
        pdf.setDrawColor(220);
        pdf.line(10, 33, pageWidth - 10, 33);
        pdf.line(10, pageHeight - 15, pageWidth - 10, pageHeight - 15);
        pdf.setFontSize(9);
        pdf.text(`Generated on ${new Date().toLocaleDateString()}`, 14, pageHeight - 8);
        const str = `Page ${pdf.internal.getCurrentPageInfo().pageNumber} of ${pdf.internal.getNumberOfPages()}`;
        pdf.text(str, pageWidth - 40, pageHeight - 8);
      },
    });

    pdf.save(`Model-Price-List.pdf`);
    toast.dismiss();
    toast.success("Download completed!");
  } catch (error) {
    toast.dismiss();
    toast.error("PDF generation failed");
    console.error(error);
  }
};

  return (
    <div
      className={`
        rounded-3xl p-4 md:p-8 transition-all duration-300
        ${
          isRetailerMobile
            ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
            : "bg-white shadow-2xl"
        }
      `}
    >

      {/* ================= TOP BAR ================= */}
        <div className="mb-6">

          {/* -------- MOBILE TOP BAR -------- */}
          <div className="flex flex-col gap-3 md:hidden">

  {/* Categories + Brands */}
  <div className="grid grid-cols-2 gap-2">

    <select
      value={selectedCategoryId}
      onChange={(e) => setSelectedCategoryId(e.target.value)}
      className="
      w-full
      px-3 py-2
      rounded-xl
      text-sm
      bg-white
      border border-slate-200
      text-slate-800
      shadow-sm
      focus:outline-none
      "
    >
      <option value="">All Categories</option>

      {categories.map((cat) => (
        <option key={cat.id} value={cat.id}>
          {cat.name}
        </option>
      ))}
    </select>

    <select
      value={selectedBrandId}
      onChange={(e) => setSelectedBrandId(e.target.value)}
      className="
      w-full
      px-3 py-2
      rounded-xl
      text-sm
      bg-white
      border border-slate-200
      text-slate-800
      shadow-sm
      focus:outline-none
      "
    >
      <option value="">All Brands</option>

      {brands.map((brand) => (
        <option key={brand.id} value={brand.id}>
          {brand.name}
        </option>
      ))}
    </select>

  </div>


  {/* Search + Actions */}
  <div className="flex gap-2">

    <input
      type="text"
      placeholder="Search model..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="
      flex-1
      px-3 py-2
      rounded-xl
      text-sm
      bg-white
      border border-slate-200
      text-slate-800
      placeholder:text-slate-400
      shadow-sm
      focus:outline-none
      "
    />

    <button
      onClick={handleResetFilters}
      className="
      w-8 h-10 shrink-0
      rounded-xl
      bg-slate-100
      border border-slate-200
      flex items-center justify-center
      "
    >
      <RotateCcw size={18} />
    </button>

    <button
      onClick={handleDownload}
      className="
      w-8 h-10 shrink-0
      rounded-xl
      bg-blue-600
      text-white
      flex items-center justify-center
      "
    >
      <Download className="w-4 h-4" />
    </button>

  </div>

</div>

          {/* -------- DESKTOP TOP BAR -------- */}
          <div className="hidden md:flex flex-wrap items-center gap-3">

              {/* Left Filters */}
              <div className="flex flex-wrap items-center gap-3 flex-1 min-w-[250px]">

                <select
                  value={selectedCategoryId}
                  onChange={(e) => setSelectedCategoryId(e.target.value)}
                  className="px-4 py-2 border rounded-xl text-sm focus:ring-2 focus:ring-blue-400"
                >
                  <option value="">All Categories</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>

                <select
                  value={selectedBrandId}
                  onChange={(e) => setSelectedBrandId(e.target.value)}
                  className="px-4 py-2 border rounded-xl text-sm focus:ring-2 focus:ring-blue-400"
                >
                  <option value="">All Brands</option>
                  {brands.map((brand) => (
                    <option key={brand.id} value={brand.id}>
                      {brand.name}
                    </option>
                  ))}
                </select>

                <input
                  type="text"
                  placeholder="Search model..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="flex-1 min-w-[180px] md:min-w-[220px] lg:w-80 px-4 py-2 border rounded-xl focus:ring-2 focus:ring-blue-400 text-sm"
                />

              </div>

              {/* Right Buttons */}
              <div className="flex flex-wrap items-center gap-2 ml-auto">

                <button
                  onClick={handleResetFilters}
                  className="px-4 py-2 rounded-xl bg-slate-200 text-slate-700 text-sm font-medium hover:bg-slate-300 transition"
                >
                  Reset
                </button>

                <button
                  onClick={handleDownload}
                  className="px-5 py-2 rounded-xl bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition shadow-md"
                >
                  Download
                </button>

                <RefreshButton onClick={fetchPriceReport} />

              </div>

            </div>

        </div>

     {loading ? (
        <div className="flex justify-center py-24">
          <RegularLoader size={90} />
        </div>
      ) : selectedBrand && filteredModels.length === 0 ? (
        /* Empty State */
        <div className="text-center py-24">
          <div className="text-lg font-semibold text-slate-700">
            No models found
          </div>
          <div className="text-sm text-slate-500 mt-2">
            Please select a different brand to view model wise price list.
          </div>
          <button
            onClick={() => setSelectedBrand("")}
            className="mt-6 px-5 py-2 bg-blue-600 text-white rounded-xl"
          >
            View All Brands
          </button>
        </div>
      ) : (
        <>
        <div className="md:hidden space-y-6">
          {filteredModels.map((item, index) => (
            // <div key={index} className="bg-white rounded-3xl shadow-lg border p-5">
            //   <div className="mb-4">
            //     <div className="font-semibold text-lg text-slate-800">
            //       {item.model}
            //     </div>

                
            //     <div className="text-xs text-blue-600 font-medium mt-1">
            //       {item.brand}
            //     </div>
                
            //     <div className="text-sm text-slate-500">
            //       Device Price ₹{item.devicePrice.toLocaleString()}
            //     </div>
            //   </div>

            //   {productTypes.map((type, index) => {
            //     const colors = {
            //       "Screen Damage": "blue",
            //       "Total Protection": "violet",
            //       "Extended Warranty": "amber",
            //     };

            //     return (
            //       <MobileSection
            //         key={index}
            //         title={type}
            //         color={colors[type] || "blue"}
            //         plans={item[type] || []}
            //       />
            //     );
            //   })}
            // </div>

            <div
              key={index}
              className={cn(
                "rounded-3xl p-5 transition-all duration-300",
                isRetailerMobile
                  ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
                  : "bg-white border border-slate-200 shadow-lg"
              )}
            >
              <div className="mb-4">
                <div
                  className={cn(
                    "font-semibold text-lg",
                    isRetailerMobile ? "text-slate-800" : "text-slate-800"
                  )}
                >
                  {item.model}
                </div>

                <div
                  className={cn(
                    "text-xs font-medium mt-1",
                    isRetailerMobile ? "text-blue-700" : "text-blue-600"
                  )}
                >
                  {item.brand}
                </div>

                <div
                  className={cn(
                    "text-sm",
                    isRetailerMobile ? "text-slate-700" : "text-slate-500"
                  )}
                >
                  Device Price ₹{item.devicePrice.toLocaleString()}
                </div>
              </div>

              {productTypes.map((type, index) => {
                const colors = {
                  "Screen Damage": "blue",
                  "Total Protection": "violet",
                  "Extended Warranty": "amber",
                };

                return (
                  <MobileSection
                    key={index}
                    title={type}
                    color={colors[type] || "blue"}
                    plans={item[type] || []}
                    isRetailerMobile={isRetailerMobile}   // 👈 pass this if needed inside
                  />
                );
              })}
            </div>
          ))}
        </div>

        {/* ================= DESKTOP VIEW ================= */}
        <div className="hidden md:block">
          <div className="hidden md:block">
          <div
              
              className="max-h-[70vh] overflow-y-auto rounded-2xl"
            >
              {/* HEADER */}
              <div
                className="grid text-sm font-semibold"
                style={{ gridTemplateColumns: gridTemplate }}
              >

                <div className="col-span-1 px-4 py-3 bg-slate-50 rounded-tl-2xl">Models</div>
                {productTypes.map((type, index) => {
                  const color = sectionColors[index % sectionColors.length];

                  return (
                    <div
                      key={type}
                      className={`px-4 py-3 text-center font-semibold ${color.header}`}
                      style={{
                        gridColumn: `span ${validityMap[type]?.length || 1}`,
                      }}
                    >
                      {type}
                    </div>
                  );
                })}

              </div>

              {/* Sub Header Badges */}
              <div
                className="grid text-xs font-medium items-center"
                style={{ gridTemplateColumns: gridTemplate }}
              >
                <div></div>

                {productTypes.map((type, index) => {
                  const color = sectionColors[index % sectionColors.length];

                  return validityMap[type]?.length > 0
                    ? validityMap[type].map((days) => (
                        <div
                          key={`${type}-${days}`}
                          className={`flex items-center justify-center h-16 ${color.cell}`}
                        >
                          <span
                            className={`inline-flex items-center justify-center 
                                        w-28 h-9 rounded-full border-2 bg-white 
                                        text-[11px] font-bold 
                                        ${color.badgeBorder} ${color.badgeText}`}
                          >
                            {days} Days
                          </span>
                        </div>
                      ))
                    : (
                        <div
                          key={type}
                          className={`flex items-center justify-center h-16 ${color.cell}`}
                        >
                          -
                        </div>
                      );
                })}
              </div>

              {/* BODY */}
              <div>
                {filteredModels.map((item, rowIndex) => (
                  <div
                    key={rowIndex}
                    className="grid border-b border-dotted border-slate-700"
                    style={{ gridTemplateColumns: gridTemplate }}
                  >
                    {/* MODEL COLUMN */}
                    <div className="py-4 px-3 lg:py-6 lg:px-4">
                      <div className="font-semibold break-words">
                        {item.model}
                      </div>

                      <div className="text-sm text-blue-800 font-semibold mt-1">
                        {item.brand}
                      </div>
                      <div className="text-xs text-slate-500">
                        ₹{item.devicePrice.toLocaleString()}
                      </div>
                    </div>

                    {productTypes.map((type, index) => {
                        const color = sectionColors[index % sectionColors.length];

                        if (validityMap[type]?.length > 0) {
                          return validityMap[type].map((days) => {
                            const plan = (item[type] || []).find(
                              (p) => p.validity === days
                            );

                            return (
                              <SingleCell
                                key={`${type}-${days}-${rowIndex}`}
                                item={plan}
                                bg={color.cell}
                                text={color.text}
                                tooltipKey={`${type}-${days}-${rowIndex}`}
                                activeTooltip={activeTooltip}
                                setActiveTooltip={setActiveTooltip}
                              />
                            );
                          });
                        }

                        return (
                          <SingleCell
                            key={`${type}-empty-${rowIndex}`}
                            item={null}
                            bg={color.cell}
                            text={color.text}
                          />
                        );
                      })}
                  </div>
                ))}
              </div>
          </div>
          </div>
        </div>

        {/* ================= HIDDEN PRINTABLE TABLE ================= */}
        <div
          style={{
            position: "absolute",
            left: "-9999px",
            top: 0,
            width: "1200px", // 👈 VERY IMPORTANT
          }}
        >
          <div ref={tableRef} className="bg-white p-8">
            <h1 className="text-2xl font-bold mb-4">Model Wise Price List</h1>
            
            {/* Table Header */}
            <div className="grid border-b" style={{ gridTemplateColumns: `250px repeat(${productTypes.length * 2}, 1fr)` }}>
              <div className="p-4 bg-slate-50 font-bold">Models</div>
              {productTypes.map((type) => {
                const bgColors = {
                  "Screen Damage": "bg-[#DBEAFE]", // Light Blue
                  "Total Protection": "bg-[#EDE9FE]", // Light Violet
                  "Extended Warranty": "bg-[#FEF3C7]", // Light Amber
                };
                return (
                  <div key={type} className={`col-span-2 p-4 text-center font-bold border-l ${bgColors[type] || 'bg-gray-100'}`}>
                    {type}
                  </div>
                );
              })}
            </div>

            {/* Table Sub-Header (The 545/730 Days Pills) */}
            <div className="grid border-b" style={{ gridTemplateColumns: `250px repeat(${productTypes.length * 2}, 1fr)` }}>
              <div className="bg-slate-50 border-r"></div>
              {productTypes.map((type) => (
                <React.Fragment key={type}>
                  <div className="p-2 flex justify-center border-l"><span className="px-4 py-1 rounded-full border border-blue-600 text-[10px] font-bold text-blue-700 bg-white">545 Days</span></div>
                  <div className="p-2 flex justify-center border-l"><span className="px-4 py-1 rounded-full border border-blue-600 text-[10px] font-bold text-blue-700 bg-white">730 Days</span></div>
                </React.Fragment>
              ))}
            </div>

            {/* Table Body */}
            {filteredModels.map((item, idx) => (
              <div key={idx} className="grid border-b" style={{ gridTemplateColumns: `250px repeat(${productTypes.length * 2}, 1fr)` }}>
                <div className="p-4 border-r">
                  <div className="font-bold text-sm">{item.model}</div>
                  <div className="text-blue-600 font-bold text-xs">{item.brand}</div>
                  <div className="text-gray-500 text-xs">₹{item.devicePrice.toLocaleString()}</div>
                </div>
                {productTypes.map((type) => (
                  <React.Fragment key={type}>
                    <PrintCellContent data={item[type]?.first} />
                    <PrintCellContent data={item[type]?.second} />
                  </React.Fragment>
                ))}
              </div>
            ))}
          </div>
        </div>
      </>
      )}
    </div>
  );
}

/* ================= PRICE COLUMN ================= */

function SingleCell({ item = {}, bg, text, tooltipKey, activeTooltip, setActiveTooltip }) {
  const hasData =
  item &&
  item.price !== "-" &&
  item.price !== null &&
  item.price !== undefined;
  const isOpen = activeTooltip === tooltipKey;

  return (
    <div className={`py-6 px-3 text-center relative ${bg}`}>
      {hasData ? (
        <>
          <div className={`font-bold ${text}`}>
            ₹{item.price}
          </div>

          {/* PROFIT */}
          {item.profit !== "-" && (
            <div className="inline-block mt-2 px-2  text-[11px] font-bold rounded-full 
                            bg-gradient-to-r from-emerald-500 to-green-600 
                            text-white shadow-md">
              Profit ₹{item.profit}
            </div>
          )}

          <div className="text-xs text-emerald-600 font-semibold">
            {item.sublabel}
          </div>

          <div className="flex justify-center items-center gap-1 mt-1 text-xs text-slate-600 relative">
            <span className="truncate max-w-[120px]">
              {item.name}
            </span>

            {/* INFO BUTTON */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setActiveTooltip(isOpen ? null : tooltipKey);
              }}
            >
              <Info size={14} className="text-slate-500 hover:text-slate-700" />
            </button>

            {/* TOOLTIP */}
            {isOpen && (
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 z-50">
                <div className="relative bg-white border shadow-lg rounded-lg p-3 w-56 text-xs text-slate-600">
                  {item.desc}
                  <div className="absolute left-1/2 -translate-x-1/2 bottom-full w-3 h-3 bg-white border-r border-t rotate-45"></div>
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="text-slate-900 font-bold pt-4">-</div>
      )}
    </div>
  );
}


function MobileSection({ title, color, plans = [] }) {

  const colors = {
    blue: { bg: "bg-blue-100", text: "text-blue-700" },
    violet: { bg: "bg-violet-100", text: "text-violet-700" },
    amber: { bg: "bg-amber-100", text: "text-amber-700" },
  };

  const style = colors[color] || colors.blue;

  return (
    <div className="mb-4">
      <div className={`text-sm font-semibold mb-2 ${style.text}`}>
        {title}
      </div>

      {plans.length === 0 ? (
        <div className="text-xs text-gray-400">No plans available</div>
      ) : (
        plans.map((item, index) => (
          <div key={index} className="relative mb-3">
            <div className={`flex justify-between p-4 rounded-xl ${style.bg}`}>
              <div>
                <div className="text-xs text-slate-500">
                  {item?.validity
                    ? `${item.validity} Days`
                    : "-"}
                </div>

                <div className="text-sm font-semibold text-slate-800">
                  {item?.name || "-"}
                </div>

                <div className="text-xs text-emerald-600 font-semibold mt-1">
                  {item?.sublabel || "-"}
                </div>

                {item?.profit !== "-" && item?.profit !== undefined && (
                  <div className="inline-block mt-2 px-3 py-1 text-[11px] font-bold rounded-full 
                                  bg-gradient-to-r from-emerald-500 to-green-600 
                                  text-white shadow-md">
                    Profit ₹{item.profit}
                  </div>
                )}
              </div>

              <div className={`font-bold text-lg ${style.text}`}>
                {item?.price !== "-" ? `₹${item.price}` : "-"}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

const PrintCellContent = ({ data }) => {
  if (!data || data.price === "-") {
    return <div className="p-4 text-center border-l text-gray-400">-</div>;
  }
  return (
    <div className="p-6 text-center border-l flex flex-col items-center justify-center space-y-2">
      <div className="font-bold text-lg">₹{data.price}</div>
      <div
        style={{
          backgroundColor: "#16a34a",
          color: "white",
          padding: "4px 10px",
          borderRadius: "20px",
          fontSize: "11px",
          fontWeight: "bold",
          display: "inline-block",
          marginTop: "6px",
          marginBottom: "6px",
        }}
      >
        Profit ₹{data.profit}
      </div>
      <div className="text-[10px] text-emerald-600 font-bold">{data.sublabel}</div>
    </div>
  );
};


// const handleDownload = async () => {
//   try {
//     toast.loading("Generating PDF...");

//     await new Promise((r) => setTimeout(r, 50));

//     const pdf = new jsPDF("l", "mm", "a4");

//     await loadFont(pdf);

//     const logoBase64 = await getBase64FromUrl("/icons/goelectronix-logo.png");

//     /* ================= DYNAMIC HEADERS ================= */

//     const headRow1 = [
//       {
//         content: "Models",
//         rowSpan: 2,
//         styles: {
//           fillColor: false,          // ❌ remove background
//           textColor: [0, 0, 0],      // black text
//           fontSize: 10             // 🔥 larger font
//         },
//       },
//     ];

//     productTypes.forEach((type) => {
//       const colors = {
//         "Screen Damage": [191, 219, 254],
//         "Total Protection": [221, 214, 254],
//         "Extended Warranty": [254, 243, 199],
//       };

//       headRow1.push({
//         content: type,
//         colSpan: 2,
        
//         styles: { fillColor: colors[type] || [240, 240, 240], textColor: [0, 0, 0], fontSize: 10 },
//       });
//     });

//     const headRow2 = [];

//     productTypes.forEach((type) => {

//       const colors = {
//         "Screen Damage": [191, 219, 254],
//         "Total Protection": [221, 214, 254],
//         "Extended Warranty": [254, 243, 199],
//       };

//       const bgColor = colors[type] || [240, 240, 240];

//       headRow2.push(
//         {
//           content: "",
//           styles: {
//             fillColor: bgColor,
//             textColor: [0, 0, 0]
//           }
//         },
//         {
//           content: "",
//           styles: {
//             fillColor: bgColor,
//             textColor: [0, 0, 0]
//           }
//         }
//       );
//     });

//     const head = [headRow1, headRow2];

//     /* ================= BODY ================= */

//     const cellDataMap = {};

//     const body = filteredModels.map((item, rowIndex) => {
//       const row = [""];

//       productTypes.forEach((type) => {
//         const first = item[type]?.first;
//         const second = item[type]?.second;

//         const firstKey = `${rowIndex}-${type}-1`;
//         const secondKey = `${rowIndex}-${type}-2`;

//         if (first?.price !== "-") {
//           cellDataMap[firstKey] = first;
//           row.push("");
//         } else row.push("-");

//         if (second?.price !== "-") {
//           cellDataMap[secondKey] = second;
//           row.push("");
//         } else row.push("-");
//       });

//       return row;
//     });

//     /* ================= TABLE ================= */

//     autoTable(pdf, {
//       head,
//       body,
      
//       theme: "grid",

//       headStyles: {
//         textColor: [0, 0, 0],   // 🔥 force black
//         halign: "center",
//         fontStyle: "bold"
//       },

//       margin: {
//         top: 40,     // space for logo + title
//         bottom: 20
//       },

//       rowPageBreak: "avoid",

//       styles: {
//         font: "NotoSans",
        
//         fontSize: 8,
//         cellPadding: 4,
//         valign: "top",
//         lineColor: [230, 230, 230],
//         lineWidth: 0.3,
//       },

//       columnStyles: {
//         0: { cellWidth: 45 },
//       },

//       didParseCell: function (data) {

        

//         /* ================= BODY COLUMN BACKGROUND ================= */

//         if (data.section === "body" && data.column.index !== 0) {

//           const colors = {
//             "Screen Damage": [191, 219, 254],
//             "Total Protection": [221, 214, 254],
//             "Extended Warranty": [254, 243, 199],
//           };

//           const typeIndex = Math.floor((data.column.index - 1) / 2);
//           const type = productTypes[typeIndex];

//           const bgColor = colors[type] || [255, 255, 255];

//           // 🔥 APPLY SECTION BACKGROUND
//           data.cell.styles.fillColor = bgColor;
//           data.cell.styles.textColor = [0, 0, 0];

//           // keep your row height
//           data.row.height = 35;
//         }
//       },

//       didDrawCell: function (data) {

//         /* ================= MODEL COLUMN CUSTOM DRAW ================= */

//         if (data.section === "body" && data.column.index === 0) {

//           const item = filteredModels[data.row.index];
//           const centerX = data.cell.x + 4;
//           let y = data.cell.y + 8;

//           /* ===== MODEL (Large + Bold) ===== */

//           pdf.setFont("NotoSans", "bold");
//           pdf.setFontSize(11);
//           pdf.setTextColor(0, 0, 0);

//           const wrappedModel = pdf.splitTextToSize(
//             item.model,
//             data.cell.width - 8
//           );

//           wrappedModel.forEach((line, i) => {
//             pdf.text(line, centerX, y + i * 5);
//           });

//           y += wrappedModel.length * 5 + 2;

//           /* ===== BRAND (Blue) ===== */

//           pdf.setFont("NotoSans", "bold");
//           pdf.setFontSize(9);
//           pdf.setTextColor(37, 99, 235); // Blue

//           pdf.text(item.brand, centerX, y);

//           y += 6;

//           /* ===== DEVICE PRICE (Gray) ===== */

//           pdf.setFont("NotoSans", "normal");
//           pdf.setFontSize(8);
//           pdf.setTextColor(120, 120, 120);

//           pdf.text(
//             `₹${item.devicePrice?.toLocaleString()}`,
//             centerX,
//             y
//           );

//           return;
//         }

//         /* ================= HEADER BADGES ================= */

//         if (data.section === "head" && data.row.index === 1) {

//           const colIndex = data.column.index;
//           if (colIndex === 0) return;

//           const isSecond = (colIndex - 1) % 2 === 1;
//           const label = isSecond ? "730 Days" : "545 Days";

//           const badgeWidth = 20;
//           const badgeHeight = 8;

//           const x = data.cell.x + (data.cell.width - badgeWidth) / 2;
//           const y = data.cell.y + (data.cell.height - badgeHeight) / 2;

//           const sectionBorderColors = {
//             "Screen Damage": [37, 99, 235],     // Blue
//             "Total Protection": [124, 58, 237], // Violet
//             "Extended Warranty": [234, 88, 12], // Orange
//           };

//           const sectionType = productTypes[Math.floor((colIndex - 1) / 2)];
//           const borderColor = sectionBorderColors[sectionType] || [16, 185, 129];

//           pdf.setFillColor(255, 255, 255);      // white background
//           pdf.setDrawColor(...borderColor);     // dynamic border color
//           pdf.setLineWidth(0.8);
//           pdf.setLineWidth(0.6);
//           pdf.roundedRect(x, y, badgeWidth, badgeHeight, 4, 4, "FD");

//           pdf.setFontSize(7);
//           pdf.setTextColor(...borderColor);

//           const textWidth = pdf.getTextWidth(label);
//           pdf.text(label, x + (badgeWidth - textWidth) / 2, y + 5);

//           return;
//         }

//         /* ================= BODY CELLS ================= */

//         if (data.section === "body" && data.column.index !== 0) {

//           const rowIndex = data.row.index;
//           const colIndex = data.column.index;

//           const typeIndex = Math.floor((colIndex - 1) / 2);
//           const isSecond = (colIndex - 1) % 2 === 1;

//           const type = productTypes[typeIndex];
//           const key = `${rowIndex}-${type}-${isSecond ? 2 : 1}`;

//           const cellData = cellDataMap[key];
//           if (!cellData) return;

//           const { price, profit, sublabel, name } = cellData;

//           const x = data.cell.x + 4;
//           const y = data.cell.y + 6;

//           // Price
//           pdf.setFont("NotoSans", "bold");   // ✅ Bold
//           pdf.setFontSize(11);
//           pdf.setTextColor(180, 83, 9);

//           // Center horizontally inside cell
//           pdf.text(
//             `₹${price}`,
//             data.cell.x + data.cell.width / 2,
//             y,
//             { align: "center" }
//           );

//           // Switch back to normal after
//           pdf.setFont("NotoSans", "normal");

//           // Profit badge
//           const profitText = `Profit ₹${profit}`;
//           pdf.setFont("NotoSans", "bold");
//           pdf.setFontSize(8);
//           const textWidth = pdf.getTextWidth(profitText);

//           pdf.setFillColor(16, 185, 129);
//           pdf.roundedRect(x, y + 3, textWidth + 8, 6, 4, 4, "F");

//           pdf.setTextColor(255);
//           pdf.text(profitText, x + 4, y + 7);

//           // Days + Claims
//           pdf.setFont("NotoSans", "bold");   // match UI bold
//           pdf.setFontSize(9);
//           pdf.setTextColor(16, 185, 129);

//           // Center horizontally
//           pdf.text(
//             sublabel,
//             data.cell.x + data.cell.width / 2,
//             y + 13,
//             { align: "center" }
//           );

//           // Product Name
//           pdf.setFont("NotoSans", "normal");
//           pdf.setFontSize(8);
//           pdf.setTextColor(100, 100, 100); // slate color

//           const wrappedName = pdf.splitTextToSize(
//             name,
//             data.cell.width - 8
//           );

//           pdf.text(wrappedName, x, y + 18);
//         }
//       },

//       didDrawPage: function (data) {
//         const pageHeight = pdf.internal.pageSize.getHeight();
//         const pageWidth = pdf.internal.pageSize.getWidth();

//         /* ================= WATERMARK ================= */

//         pdf.setFont("NotoSans", "bold");
//         pdf.setFontSize(60);
//         pdf.setTextColor(200, 200, 200);

//         pdf.saveGraphicsState();
//         pdf.setGState(new pdf.GState({ opacity: 0.08 }));

//         pdf.text(
//           "GOELECTRONIX",
//           pageWidth / 2,
//           pageHeight / 2,
//           {
//             align: "center",
//             angle: 45,
//           }
//         );

//         pdf.restoreGraphicsState();

//         /* ================= HEADER LOGO ================= */

//         if (logoBase64) {
//           pdf.addImage(
//             logoBase64,
//             "PNG",
//             14,
//             6,
//             28,
//             28
//           );
//         }

//         /* ================= COMPANY NAME ================= */

//         pdf.setFont("NotoSans", "bold");
//         pdf.setFontSize(18);
//         pdf.setTextColor(0, 51, 102);

//         pdf.text("GOELECTRONIX WARRANTY HUB", 50, 16);

//         pdf.setFont("NotoSans", "normal");
//         pdf.setFontSize(11);
//         pdf.setTextColor(80);

//         pdf.text("Model Wise Price List", 50, 24);

//         /* ================= HEADER LINE ================= */

//         pdf.setDrawColor(220);
//         pdf.line(10, 32, pageWidth - 10, 32);

//         /* ================= FOOTER ================= */

//         pdf.setDrawColor(220);
//         pdf.line(10, pageHeight - 15, pageWidth - 10, pageHeight - 15);

//         const pageCount = pdf.internal.getNumberOfPages();
//         pdf.setFontSize(9);
//         pdf.setTextColor(120);

//         pdf.text(
//           `Page ${pdf.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
//           pageWidth - 40,
//           pageHeight - 8
//         );
//       }
//     });

//     pdf.save("Model-Price-List.pdf");

//     toast.dismiss();
//     toast.success("Download completed!");
//   } catch (error) {
//     toast.dismiss();
//     toast.error("PDF generation failed");
//     console.error(error);
//   }
// };

// import { Info } from "lucide-react";
// import { useState, useEffect } from "react";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import html2canvas from "html2canvas";
// import { useRef } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../../config/api";

// export default function ModelPriceList() {
//   const [activeTooltip, setActiveTooltip] = useState(null);
//   const tableRef = useRef();

//   const [models, setModels] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // const models = [
//   //   {
//   //     model: "Vivo V50",
//   //     devicePrice: 45000,

//   //     screen545: { price: 500, name: "Screen Protect 545", sublabel: "545 Days", desc: "1 accidental screen claim for 545 days." },
//   //     screen730: { price: 900, name: "Screen Protect 730", sublabel: "730 Days", desc: "2 accidental screen claims for 730 days." },

//   //     total545: { price: 1500, name: "Total Protect 545", sublabel: "Up to Device Price", desc: "Covers screen + hardware up to device value." },
//   //     total730: { price: 2000, name: "Total Protect 730", sublabel: "Up to Device Price", desc: "Extended total coverage for 730 days." },

//   //     extended545: { price: 1200, name: "Extended 545", sublabel: "100% Coverage", desc: "Manufacturing defect coverage for 545 days." },
//   //     extended730: { price: 1700, name: "Extended 730", sublabel: "100% Coverage", desc: "Extended hardware protection for 730 days." },
//   //   },
//   //   {
//   //     model: "Samsung A54",
//   //     devicePrice: 38000,

//   //     screen545: { price: 450, name: "Screen Protect 545", sublabel: "1 Claim", desc: "1 accidental screen claim for 545 days." },
//   //     screen730: { price: 850, name: "Screen Protect 730", sublabel: "3 Claim", desc: "2 accidental screen claims for 730 days." },

//   //     total545: { price: 1400, name: "Total Protect 545", sublabel: "Up to Device Price", desc: "Covers screen + hardware up to device value." },
//   //     total730: { price: 1900, name: "Total Protect 730", sublabel: "Up to Device Price", desc: "Extended total coverage for 730 days." },

//   //     extended545: { price: 1100, name: "Extended 545", sublabel: "100% Coverage", desc: "Manufacturing defect coverage for 545 days." },
//   //     extended730: { price: 1600, name: "Extended 730", sublabel: "100% Coverage", desc: "Extended hardware protection for 730 days." },
//   //   }
//   // ];

//   useEffect(() => {
//   const fetchPriceReport = async () => {
//     try {
//       setLoading(true);

//       const response = await axios.get(
//         `${BASE_URL}warranty/price-report?company_id=5927`
//       );

//       if (response.data.success) {
//         const transformed = transformApiData(response.data.data);
//         setModels(transformed);
//       }

//     } catch (error) {
//       console.error("Price Report API Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchPriceReport();
// }, []);

// const transformApiData = (apiArray) => {
//   return apiArray.map((item) => {
//     const packages = item.packages || [];

//     const groupByType = (type) =>
//       packages
//         .filter((p) => p.product_type === type)
//         .sort((a, b) => (a.validity_days || 0) - (b.validity_days || 0));

//     const screenPlans = groupByType("Screen Damage");
//     const totalPlans = groupByType("Total Protection");
//     const extendedPlans = groupByType("Extended Warranty");

//     const formatPlan = (plan) => {
//       if (!plan) {
//         return {
//           price: "-",
//           name: "-",
//           sublabel: "-",
//           desc: "-",
//         };
//       }

//       return {
//         price: plan.product_price
//           ? Number(plan.product_price)
//           : "-",
//         name: plan.product_name || "-",
//         sublabel: plan.validity_days
//           ? `${plan.validity_days} Days`
//           : plan.claims
//           ? `${plan.claims} Claims`
//           : "-",
//         desc: plan.product_name || "-",
//       };
//     };

//     return {
//       model: item.model,
//       devicePrice: Number(item.device_price),

//       // FIRST & SECOND PLAN OF EACH TYPE (Dynamic)
//       screen545: formatPlan(screenPlans[0]),
//       screen730: formatPlan(screenPlans[1]),

//       total545: formatPlan(totalPlans[0]),
//       total730: formatPlan(totalPlans[1]),

//       extended545: formatPlan(extendedPlans[0]),
//       extended730: formatPlan(extendedPlans[1]),
//     };
//   });
// };

//   /* ================= SEARCH ================= */
//   const [search, setSearch] = useState("");

//   const filteredModels = models.filter((item) =>
//     item.model.toLowerCase().includes(search.toLowerCase())
//   );

//   /* ================= PDF DOWNLOAD ================= */
//   const handleDownloadPDF = async () => {
//   const element = tableRef.current;

//   const originalWidth = element.style.width;
//   element.style.width = element.scrollWidth + "px"; // 🔥 lock width

//   const canvas = await html2canvas(element, {
//   scale: 2,
//   useCORS: true,
//   backgroundColor: "#ffffff",
//   logging: false, // Clean up console
//   letterRendering: true, // Improves text positioning in some browsers
//   width: element.scrollWidth,
//   windowWidth: element.scrollWidth,
// });

//   element.style.width = originalWidth;

//   const imgData = canvas.toDataURL("image/png");

//   const pdf = new jsPDF("l", "mm", "a4");
//   const pdfWidth = pdf.internal.pageSize.getWidth();
//   const pdfHeight = pdf.internal.pageSize.getHeight();

//   /* HEADER */
//   const logo = "/icons/goelectronix-logo.png";
//   pdf.addImage(logo, "PNG", 10, 8, 25, 25);

//   pdf.setFont("helvetica", "bold");
//   pdf.setFontSize(18);
//   pdf.text("Model Wise Price List", pdfWidth / 2, 20, { align: "center" });

//   pdf.setFontSize(10);
//   pdf.setFont("helvetica", "normal");
//   pdf.text(
//     `Generated on: ${new Date().toLocaleDateString()}`,
//     pdfWidth - 60,
//     15
//   );

//   /* TABLE IMAGE */
//   const imgWidth = pdfWidth - 20;
//   const imgHeight = (canvas.height * imgWidth) / canvas.width;

//   let position = 40;
//   let heightLeft = imgHeight;

//   pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
//   heightLeft -= pdfHeight - 40;

//   while (heightLeft > 0) {
//     pdf.addPage();
//     position = -heightLeft + 40;
//     pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
//     heightLeft -= pdfHeight;
//   }

//   pdf.save("ModelPriceList.pdf");
// };

//   return (
//     <div className="bg-white rounded-3xl shadow-2xl p-4 md:p-8">

//       {/* ================= TOP BAR ================= */}
//       <div className="flex flex-col md:flex-row md:items-center md:justify-end gap-4 mb-6">

//         <input
//           type="text"
//           placeholder="Search model..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="w-full md:w-80 px-4 py-2 border rounded-xl focus:ring-2 focus:ring-blue-400 text-sm"
//         />

//         <button
//           onClick={handleDownloadPDF}
//           className="px-5 py-2 rounded-xl bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition shadow-md"
//         >
//           Download PDF
//         </button>

//       </div>

//       <div className="md:hidden space-y-6">
//          {models.map((item, index) => (
//           <div key={index} className="bg-white rounded-3xl shadow-lg border p-5">
//             <div className="mb-4">
//               <div className="font-semibold text-lg text-slate-800">
//                 {item.model}
//               </div>
//               <div className="text-sm text-slate-500">
//                 Device Price ₹{item.devicePrice.toLocaleString()}
//               </div>
//             </div>

//             <MobileSection title="Screen Damage" color="blue" first={item.screen545} second={item.screen730} />
//             <MobileSection title="Total Protection" color="violet" first={item.total545} second={item.total730} />
//             <MobileSection title="Extended Warranty" color="amber" first={item.extended545} second={item.extended730} />
//           </div>
//         ))}
//       </div>

//       {/* ================= DESKTOP VIEW ================= */}
//       <div ref={tableRef} className="hidden md:block">

//         {/* HEADER */}
//         <div className="grid grid-cols-7 text-sm font-semibold">

//           <div className="px-4 py-3 bg-slate-50 rounded-tl-2xl">Models</div>
//           <div className="col-span-2 px-4 py-3 bg-blue-100 text-center">Screen Damage</div>
//           <div className="col-span-2 px-4 py-3 bg-violet-100 text-center">Total Protection</div>
//           <div className="col-span-2 px-4 py-3 bg-amber-100 text-center rounded-tr-2xl">Extended Warranty</div>

//         </div>

//         {/* Sub Header Badges */}
//         <div className="grid grid-cols-7 text-xs font-medium items-center">
//           <div></div>

//           {/* Screen Damage */}
//           <div className="flex items-center justify-center bg-blue-100 h-16">
//             <span className="inline-flex items-center justify-center w-28 h-9 rounded-full border-2 border-blue-600 text-blue-700 bg-white text-[11px] font-bold text-center leading-none">
//               1 Time Claim
//             </span>
//           </div>

//           <div className="flex items-center justify-center bg-blue-100 h-16">
//             <span className="inline-flex items-center justify-center w-28 h-9 rounded-full border-2 border-blue-600 text-blue-700 bg-white text-[11px] font-bold text-center leading-none">
//               2 Time Claim
//             </span>
//           </div>

//           {/* Total Protection */}
//           <div className="flex items-center justify-center bg-violet-100 h-16">
//             <span className="inline-flex items-center justify-center w-24 h-8 rounded-full border border-violet-500 text-violet-700 bg-white font-semibold leading-none">
//               545 Days
//             </span>
//           </div>

//           <div className="flex items-center justify-center bg-violet-100 h-16">
//             <span className="inline-flex items-center justify-center w-24 h-8 rounded-full border border-violet-500 text-violet-700 bg-white font-semibold leading-none">
//               730 Days
//             </span>
//           </div>

//           {/* Extended Warranty */}
//           <div className="flex items-center justify-center bg-amber-100 h-16">
//             <span className="inline-flex items-center justify-center w-24 h-8 rounded-full border border-amber-500 text-amber-700 bg-white font-semibold leading-none">
//               545 Days
//             </span>
//           </div>

//           <div className="flex items-center justify-center bg-amber-100 h-16">
//             <span className="inline-flex items-center justify-center w-24 h-8 rounded-full border border-amber-500 text-amber-700 bg-white font-semibold leading-none">
//               730 Days
//             </span>
//           </div>
//         </div>

//         {/* BODY */}
//         <div className="grid grid-cols-7">

//           {/* MODEL COLUMN */}
//           <div>
//             {filteredModels.map((item, index) => (
//               <div key={index} className="py-6 border-b border-dotted">
//                 <div className="font-semibold">{item.model}</div>
//                 <div className="text-xs text-slate-500">
//                   ₹{item.devicePrice.toLocaleString()}
//                 </div>
//               </div>
//             ))}
//           </div>

//           <PriceColumn columnId="screen545" bg="bg-blue-100" text="text-blue-700" data={filteredModels.map(m=>m.screen545)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip} />
//           <PriceColumn columnId="screen730" bg="bg-blue-100" text="text-blue-700" data={filteredModels.map(m=>m.screen730)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip} />
//           <PriceColumn columnId="total545" bg="bg-violet-100" text="text-violet-700" data={filteredModels.map(m=>m.total545)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip}/>
//           <PriceColumn columnId="total730" bg="bg-violet-100" text="text-violet-700" data={filteredModels.map(m=>m.total730)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip}/>
//           <PriceColumn columnId="extended545" bg="bg-amber-100" text="text-amber-700" data={filteredModels.map(m=>m.extended545)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip}/>
//           <PriceColumn columnId="extended730" bg="bg-amber-100" text="text-amber-700" data={filteredModels.map(m=>m.extended730)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip} />

//         </div>
//       </div>
//     </div>
//   );
// }

// /* ================= PRICE COLUMN ================= */

// function PriceColumn({ bg, text, data, columnId, activeTooltip, setActiveTooltip }) {

//   useEffect(() => {
//     const close = () => setActiveTooltip(null);
//     window.addEventListener("click", close);
//     return () => window.removeEventListener("click", close);
//   }, [setActiveTooltip]);

//   return (
//     <div className={`text-center px-3 ${bg}`}>
//       {data.map((item, index) => {

//         const tooltipKey = `${columnId}-${index}`;
//         const isOpen = activeTooltip === tooltipKey;

//         return (
//           <div key={index} className="py-4 border-b border-dotted relative">

//             <div className={`font-bold ${text}`}>
//               ₹{item.price}
//             </div>

//             <div className="text-xs text-emerald-600 font-semibold">
//               {item.sublabel}
//             </div>

//             <div className="flex justify-center items-center gap-1 mt-1 text-xs text-slate-600">
//              <span className="truncate block max-w-[100px]">
//                 {item.name}
//               </span>

//               <div className="relative">
//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setActiveTooltip(isOpen ? null : tooltipKey);
//                   }}
//                 >
//                   <Info size={14} className="text-slate-400" />
//                 </button>

//                 {isOpen && (
//                   <div className="absolute top-full left-0 mt-2 z-50">
//                     <div className="relative bg-white border shadow-lg rounded-lg p-3 w-56 text-xs">
//                       {item.desc}
//                       <div className="absolute left-3 bottom-full w-3 h-3 bg-white border-r border-t rotate-45"></div>
//                     </div>
//                   </div>
//                 )}
//               </div>

//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// function MobileSection({ title, color, first, second }) {
//   const [active, setActive] = useState(null);

//   const colors = {
//     blue: { bg: "bg-blue-100", text: "text-blue-700" },
//     violet: { bg: "bg-violet-100", text: "text-violet-700" },
//     amber: { bg: "bg-amber-100", text: "text-amber-700" },
//   };

//   return (
//     <div className="mb-4">
//       <div className={`text-sm font-semibold mb-2 ${colors[color].text}`}>
//         {title}
//       </div>

//       {[first, second].map((item, index) => (
//         <div key={index} className="relative mb-3">

//           <div className={`flex justify-between p-3 rounded-xl ${colors[color].bg}`}>
//             <div>
//               <div className="text-xs text-slate-500">
//                 {index === 0 ? "545 Days" : "730 Days"}
//               </div>

//               <div className="text-sm font-medium text-slate-700 flex items-center gap-1">
//                 {item.name}

//                 <div className="relative">
//                   <button onClick={() => setActive(active === index ? null : index)}>
//                     <Info size={14} className="text-slate-400" />
//                   </button>

//                   {active === index && (
//                     <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-30">
//                       <div className="absolute left-1/2 -translate-x-1/2 top-full w-3 h-3 bg-white border-l border-b rotate-45"></div>
//                       <div className="relative bg-white border shadow-lg rounded-lg p-3 w-56 text-xs text-slate-600">
//                         {item.desc}
                        
//                       </div>
//                     </div>
//                   )}
//                 </div>

//               </div>
//             </div>

//             <span className={`font-bold ${colors[color].text}`}>
//               ₹{item.price}
//             </span>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }



// import { Info } from "lucide-react";
// import { useState, useEffect } from "react";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import html2canvas from "html2canvas";
// import { useRef } from "react";
// import axios from "axios";

// export default function ModelPriceList() {
//   const [activeTooltip, setActiveTooltip] = useState(null);
//   const tableRef = useRef();

//   const models = [
//     {
//       model: "Vivo V50",
//       devicePrice: 45000,

//       screen545: { price: 500, name: "Screen Protect 545", sublabel: "545 Days", desc: "1 accidental screen claim for 545 days." },
//       screen730: { price: 900, name: "Screen Protect 730", sublabel: "730 Days", desc: "2 accidental screen claims for 730 days." },

//       total545: { price: 1500, name: "Total Protect 545", sublabel: "Up to Device Price", desc: "Covers screen + hardware up to device value." },
//       total730: { price: 2000, name: "Total Protect 730", sublabel: "Up to Device Price", desc: "Extended total coverage for 730 days." },

//       extended545: { price: 1200, name: "Extended 545", sublabel: "100% Coverage", desc: "Manufacturing defect coverage for 545 days." },
//       extended730: { price: 1700, name: "Extended 730", sublabel: "100% Coverage", desc: "Extended hardware protection for 730 days." },
//     },
//     {
//       model: "Samsung A54",
//       devicePrice: 38000,

//       screen545: { price: 450, name: "Screen Protect 545", sublabel: "1 Claim", desc: "1 accidental screen claim for 545 days." },
//       screen730: { price: 850, name: "Screen Protect 730", sublabel: "3 Claim", desc: "2 accidental screen claims for 730 days." },

//       total545: { price: 1400, name: "Total Protect 545", sublabel: "Up to Device Price", desc: "Covers screen + hardware up to device value." },
//       total730: { price: 1900, name: "Total Protect 730", sublabel: "Up to Device Price", desc: "Extended total coverage for 730 days." },

//       extended545: { price: 1100, name: "Extended 545", sublabel: "100% Coverage", desc: "Manufacturing defect coverage for 545 days." },
//       extended730: { price: 1600, name: "Extended 730", sublabel: "100% Coverage", desc: "Extended hardware protection for 730 days." },
//     }
//   ];

//   /* ================= SEARCH ================= */
//   const [search, setSearch] = useState("");

//   const filteredModels = models.filter((item) =>
//     item.model.toLowerCase().includes(search.toLowerCase())
//   );

//   /* ================= PDF DOWNLOAD ================= */
//   const handleDownloadPDF = async () => {
//   const element = tableRef.current;

//   const originalWidth = element.style.width;
//   element.style.width = element.scrollWidth + "px"; // 🔥 lock width

//   const canvas = await html2canvas(element, {
//   scale: 2,
//   useCORS: true,
//   backgroundColor: "#ffffff",
//   logging: false, // Clean up console
//   letterRendering: true, // Improves text positioning in some browsers
//   width: element.scrollWidth,
//   windowWidth: element.scrollWidth,
// });

//   element.style.width = originalWidth;

//   const imgData = canvas.toDataURL("image/png");

//   const pdf = new jsPDF("l", "mm", "a4");
//   const pdfWidth = pdf.internal.pageSize.getWidth();
//   const pdfHeight = pdf.internal.pageSize.getHeight();

//   /* HEADER */
//   const logo = "/icons/goelectronix-logo.png";
//   pdf.addImage(logo, "PNG", 10, 8, 25, 25);

//   pdf.setFont("helvetica", "bold");
//   pdf.setFontSize(18);
//   pdf.text("Model Wise Price List", pdfWidth / 2, 20, { align: "center" });

//   pdf.setFontSize(10);
//   pdf.setFont("helvetica", "normal");
//   pdf.text(
//     `Generated on: ${new Date().toLocaleDateString()}`,
//     pdfWidth - 60,
//     15
//   );

//   /* TABLE IMAGE */
//   const imgWidth = pdfWidth - 20;
//   const imgHeight = (canvas.height * imgWidth) / canvas.width;

//   let position = 40;
//   let heightLeft = imgHeight;

//   pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
//   heightLeft -= pdfHeight - 40;

//   while (heightLeft > 0) {
//     pdf.addPage();
//     position = -heightLeft + 40;
//     pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
//     heightLeft -= pdfHeight;
//   }

//   pdf.save("ModelPriceList.pdf");
// };

//   return (
//     <div className="bg-white rounded-3xl shadow-2xl p-4 md:p-8">

//       {/* ================= TOP BAR ================= */}
//       <div className="flex flex-col md:flex-row md:items-center md:justify-end gap-4 mb-6">

//         <input
//           type="text"
//           placeholder="Search model..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="w-full md:w-80 px-4 py-2 border rounded-xl focus:ring-2 focus:ring-blue-400 text-sm"
//         />

//         <button
//           onClick={handleDownloadPDF}
//           className="px-5 py-2 rounded-xl bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition shadow-md"
//         >
//           Download PDF
//         </button>

//       </div>

//       <div className="md:hidden space-y-6">
//          {models.map((item, index) => (
//           <div key={index} className="bg-white rounded-3xl shadow-lg border p-5">
//             <div className="mb-4">
//               <div className="font-semibold text-lg text-slate-800">
//                 {item.model}
//               </div>
//               <div className="text-sm text-slate-500">
//                 Device Price ₹{item.devicePrice.toLocaleString()}
//               </div>
//             </div>

//             <MobileSection title="Screen Damage" color="blue" first={item.screen545} second={item.screen730} />
//             <MobileSection title="Total Protection" color="violet" first={item.total545} second={item.total730} />
//             <MobileSection title="Extended Warranty" color="amber" first={item.extended545} second={item.extended730} />
//           </div>
//         ))}
//       </div>

//       {/* ================= DESKTOP VIEW ================= */}
//       <div ref={tableRef} className="hidden md:block">

//         {/* HEADER */}
//         <div className="grid grid-cols-7 text-sm font-semibold">

//           <div className="px-4 py-3 bg-slate-50 rounded-tl-2xl">Models</div>
//           <div className="col-span-2 px-4 py-3 bg-blue-100 text-center">Screen Damage</div>
//           <div className="col-span-2 px-4 py-3 bg-violet-100 text-center">Total Protection</div>
//           <div className="col-span-2 px-4 py-3 bg-amber-100 text-center rounded-tr-2xl">Extended Warranty</div>

//         </div>

//         {/* Sub Header Badges */}
//         <div className="grid grid-cols-7 text-xs font-medium items-center">
//           <div></div>

//           {/* Screen Damage */}
//           <div className="flex items-center justify-center bg-blue-100 h-16">
//             <span className="inline-flex items-center justify-center w-28 h-9 rounded-full border-2 border-blue-600 text-blue-700 bg-white text-[11px] font-bold text-center leading-none">
//               1 Time Claim
//             </span>
//           </div>

//           <div className="flex items-center justify-center bg-blue-100 h-16">
//             <span className="inline-flex items-center justify-center w-28 h-9 rounded-full border-2 border-blue-600 text-blue-700 bg-white text-[11px] font-bold text-center leading-none">
//               2 Time Claim
//             </span>
//           </div>

//           {/* Total Protection */}
//           <div className="flex items-center justify-center bg-violet-100 h-16">
//             <span className="inline-flex items-center justify-center w-24 h-8 rounded-full border border-violet-500 text-violet-700 bg-white font-semibold leading-none">
//               545 Days
//             </span>
//           </div>

//           <div className="flex items-center justify-center bg-violet-100 h-16">
//             <span className="inline-flex items-center justify-center w-24 h-8 rounded-full border border-violet-500 text-violet-700 bg-white font-semibold leading-none">
//               730 Days
//             </span>
//           </div>

//           {/* Extended Warranty */}
//           <div className="flex items-center justify-center bg-amber-100 h-16">
//             <span className="inline-flex items-center justify-center w-24 h-8 rounded-full border border-amber-500 text-amber-700 bg-white font-semibold leading-none">
//               545 Days
//             </span>
//           </div>

//           <div className="flex items-center justify-center bg-amber-100 h-16">
//             <span className="inline-flex items-center justify-center w-24 h-8 rounded-full border border-amber-500 text-amber-700 bg-white font-semibold leading-none">
//               730 Days
//             </span>
//           </div>
//         </div>

//         {/* BODY */}
//         <div className="grid grid-cols-7">

//           {/* MODEL COLUMN */}
//           <div>
//             {filteredModels.map((item, index) => (
//               <div key={index} className="py-6 border-b border-dotted">
//                 <div className="font-semibold">{item.model}</div>
//                 <div className="text-xs text-slate-500">
//                   ₹{item.devicePrice.toLocaleString()}
//                 </div>
//               </div>
//             ))}
//           </div>

//           <PriceColumn columnId="screen545" bg="bg-blue-100" text="text-blue-700" data={filteredModels.map(m=>m.screen545)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip} />
//           <PriceColumn columnId="screen730" bg="bg-blue-100" text="text-blue-700" data={filteredModels.map(m=>m.screen730)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip} />
//           <PriceColumn columnId="total545" bg="bg-violet-100" text="text-violet-700" data={filteredModels.map(m=>m.total545)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip}/>
//           <PriceColumn columnId="total730" bg="bg-violet-100" text="text-violet-700" data={filteredModels.map(m=>m.total730)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip}/>
//           <PriceColumn columnId="extended545" bg="bg-amber-100" text="text-amber-700" data={filteredModels.map(m=>m.extended545)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip}/>
//           <PriceColumn columnId="extended545" bg="bg-amber-100" text="text-amber-700" data={filteredModels.map(m=>m.extended730)} activeTooltip={activeTooltip} setActiveTooltip={setActiveTooltip} />

//         </div>
//       </div>
//     </div>
//   );
// }

// /* ================= PRICE COLUMN ================= */

// function PriceColumn({ bg, text, data, columnId, activeTooltip, setActiveTooltip }) {

//   useEffect(() => {
//     const close = () => setActiveTooltip(null);
//     window.addEventListener("click", close);
//     return () => window.removeEventListener("click", close);
//   }, [setActiveTooltip]);

//   return (
//     <div className={`text-center px-3 ${bg}`}>
//       {data.map((item, index) => {

//         const tooltipKey = `${columnId}-${index}`;
//         const isOpen = activeTooltip === tooltipKey;

//         return (
//           <div key={index} className="py-4 border-b border-dotted relative">

//             <div className={`font-bold ${text}`}>
//               ₹{item.price}
//             </div>

//             <div className="text-xs text-emerald-600 font-semibold">
//               {item.sublabel}
//             </div>

//             <div className="flex justify-center items-center gap-1 mt-1 text-xs text-slate-600">
//               {item.name}

//               <div className="relative">
//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setActiveTooltip(isOpen ? null : tooltipKey);
//                   }}
//                 >
//                   <Info size={14} className="text-slate-400" />
//                 </button>

//                 {isOpen && (
//                   <div className="absolute top-full left-0 mt-2 z-50">
//                     <div className="relative bg-white border shadow-lg rounded-lg p-3 w-56 text-xs">
//                       {item.desc}
//                       <div className="absolute left-3 bottom-full w-3 h-3 bg-white border-r border-t rotate-45"></div>
//                     </div>
//                   </div>
//                 )}
//               </div>

//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// function MobileSection({ title, color, first, second }) {
//   const [active, setActive] = useState(null);

//   const colors = {
//     blue: { bg: "bg-blue-100", text: "text-blue-700" },
//     violet: { bg: "bg-violet-100", text: "text-violet-700" },
//     amber: { bg: "bg-amber-100", text: "text-amber-700" },
//   };

//   return (
//     <div className="mb-4">
//       <div className={`text-sm font-semibold mb-2 ${colors[color].text}`}>
//         {title}
//       </div>

//       {[first, second].map((item, index) => (
//         <div key={index} className="relative mb-3">

//           <div className={`flex justify-between p-3 rounded-xl ${colors[color].bg}`}>
//             <div>
//               <div className="text-xs text-slate-500">
//                 {index === 0 ? "545 Days" : "730 Days"}
//               </div>

//               <div className="text-sm font-medium text-slate-700 flex items-center gap-1">
//                 {item.name}

//                 <div className="relative">
//                   <button onClick={() => setActive(active === index ? null : index)}>
//                     <Info size={14} className="text-slate-400" />
//                   </button>

//                   {active === index && (
//                     <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-30">
//                       <div className="absolute left-1/2 -translate-x-1/2 top-full w-3 h-3 bg-white border-l border-b rotate-45"></div>
//                       <div className="relative bg-white border shadow-lg rounded-lg p-3 w-56 text-xs text-slate-600">
//                         {item.desc}
                        
//                       </div>
//                     </div>
//                   )}
//                 </div>

//               </div>
//             </div>

//             <span className={`font-bold ${colors[color].text}`}>
//               ₹{item.price}
//             </span>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }


// import { Info } from "lucide-react";
// import { useState, useEffect } from "react";

// export default function ModelPriceList() {
//   const models = [
//     {
//       model: "Vivo V50",
//       devicePrice: 45000,

//       screen545: {
//         price: 500,
//         name: "Screen Protect 545",
//         sublabel: "1 claim",
//         desc: "1 accidental screen claim for 545 days."
//       },
//       screen730: {
//         price: 900,
//         name: "Screen Protect 730",
//         sublabel: "3 claim",
//         desc: "2 accidental screen claims for 730 days."
//       },

//       total545: {
//         price: 1500,
//         name: "Total Protect 545",
//         sublabel: "Up to Device Price",
//         desc: "Covers screen + hardware up to device value."
//       },
//       total730: {
//         price: 2000,
//         name: "Total Protect 730",
//         sublabel: "Up to Device Price",
//         desc: "Extended total coverage for 730 days."
//       },

//       extended545: {
//         price: 1200,
//         name: "Extended 545",
//         sublabel: "100% Coverage",
//         desc: "Manufacturing defect coverage for 545 days."
//       },
//       extended730: {
//         price: 1700,
//         name: "Extended 730",
//         sublabel: "100% Coverage",
//         desc: "Extended hardware protection for 730 days."
//       },
//     },
//     {
//       model: "Vivo V50",
//       devicePrice: 45000,

//       screen545: {
//         price: 500,
//         name: "Screen Protect 545",
//         sublabel: "1 claim",
//         desc: "1 accidental screen claim for 545 days."
//       },
//       screen730: {
//         price: 900,
//         name: "Screen Protect 730",
//         sublabel: "3 claim",
//         desc: "2 accidental screen claims for 730 days."
//       },

//       total545: {
//         price: 1500,
//         name: "Total Protect 545",
//         sublabel: "Up to Device Price",
//         desc: "Covers screen + hardware up to device value."
//       },
//       total730: {
//         price: 2000,
//         name: "Total Protect 730",
//         sublabel: "Up to Device Price",
//         desc: "Extended total coverage for 730 days."
//       },

//       extended545: {
//         price: 1200,
//         name: "Extended 545",
//         sublabel: "100% Coverage",
//         desc: "Manufacturing defect coverage for 545 days."
//       },
//       extended730: {
//         price: 1700,
//         name: "Extended 730",
//         sublabel: "100% Coverage",
//         desc: "Extended hardware protection for 730 days."
//       },
//     },
//   ];

//   return (
//     <div className="bg-white rounded-3xl shadow-2xl p-4 md:p-8">

//       {/* ================= DESKTOP VIEW ================= */}
//       <div className="hidden md:block overflow-x-auto">

//         {/* HEADER */}
//         <div className="grid grid-cols-7 text-sm font-semibold">

//           <div className="px-4 py-3 bg-slate-50 text-slate-700 rounded-tl-2xl">
//             Models
//           </div>

//           <div className="col-span-2 px-4 py-3 bg-blue-100 text-blue-700 text-center">
//             Screen Damage
//           </div>

//           <div className="col-span-2 px-4 py-3 bg-violet-100 text-violet-700 text-center">
//             Total Protection
//           </div>

//           <div className="col-span-2 px-4 py-3 bg-amber-100 text-amber-700 text-center rounded-tr-2xl">
//             Extended Warranty
//           </div>
//         </div>

//         {/* SUB HEADER */}
//         <div className="grid grid-cols-7 text-xs font-medium">

//           <div></div>

//           {/* Screen Damage */}
//           <div className="flex justify-center bg-blue-100 py-2">
//             <span className="px-4 py-1 rounded-full border border-blue-500 text-blue-700 bg-white font-semibold shadow-sm">
//               545 Days
//             </span>
//           </div>

//           <div className="flex justify-center bg-blue-100 py-2">
//             <span className="px-4 py-1 rounded-full border border-blue-500 text-blue-700 bg-white font-semibold shadow-sm">
//               730 Days
//             </span>
//           </div>

//           {/* Total Protection */}
//           <div className="flex justify-center bg-violet-100 py-2">
//             <span className="px-4 py-1 rounded-full border border-violet-500 text-violet-700 bg-white font-semibold shadow-sm">
//               545 Days
//             </span>
//           </div>

//           <div className="flex justify-center bg-violet-100 py-2">
//             <span className="px-4 py-1 rounded-full border border-violet-500 text-violet-700 bg-white font-semibold shadow-sm">
//               730 Days
//             </span>
//           </div>

//           {/* Extended Warranty */}
//           <div className="flex justify-center bg-amber-100 py-2">
//             <span className="px-4 py-1 rounded-full border border-amber-500 text-amber-700 bg-white font-semibold shadow-sm">
//               545 Days
//             </span>
//           </div>

//           <div className="flex justify-center bg-amber-100 py-2">
//             <span className="px-4 py-1 rounded-full border border-amber-500 text-amber-700 bg-white font-semibold shadow-sm">
//               730 Days
//             </span>
//           </div>

//         </div>

//         {/* BODY */}
//         <div className="grid grid-cols-7">

//           {/* MODEL COLUMN */}
//           <div>
//             {models.map((item, index) => (
//               <div key={index} className="py-6 border-b border-dotted border-slate-300">
//                 <div className="font-semibold text-slate-800">
//                   {item.model}
//                 </div>
//                 <div className="text-xs text-slate-500 mt-1">
//                   Device Price ₹{item.devicePrice.toLocaleString()}
//                 </div>
//               </div>
//             ))}
//           </div>

//           <PriceColumn bg="bg-blue-100" text="text-blue-700" data={models.map(m => m.screen545)} />
//           <PriceColumn bg="bg-blue-100" text="text-blue-700" data={models.map(m => m.screen730)} />
//           <PriceColumn bg="bg-violet-100" text="text-violet-700" data={models.map(m => m.total545)} />
//           <PriceColumn bg="bg-violet-100" text="text-violet-700" data={models.map(m => m.total730)} />
//           <PriceColumn bg="bg-amber-100" text="text-amber-700" data={models.map(m => m.extended545)} />
//           <PriceColumn bg="bg-amber-100" text="text-amber-700" data={models.map(m => m.extended730)} />

//         </div>
//       </div>

//       {/* ================= MOBILE VIEW ================= */}
//       <div className="md:hidden space-y-6">
//         {models.map((item, index) => (
//           <div key={index} className="bg-white rounded-3xl shadow-lg border p-5">
//             <div className="mb-4">
//               <div className="font-semibold text-lg text-slate-800">
//                 {item.model}
//               </div>
//               <div className="text-sm text-slate-500">
//                 Device Price ₹{item.devicePrice.toLocaleString()}
//               </div>
//             </div>

//             <MobileSection title="Screen Damage" color="blue" first={item.screen545} second={item.screen730} />
//             <MobileSection title="Total Protection" color="violet" first={item.total545} second={item.total730} />
//             <MobileSection title="Extended Warranty" color="amber" first={item.extended545} second={item.extended730} />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// /* ================= DESKTOP COLUMN ================= */

// function PriceColumn({ bg, text, data }) {
//   const [activeIndex, setActiveIndex] = useState(null);

//   useEffect(() => {
//     const close = () => setActiveIndex(null);
//     window.addEventListener("click", close);
//     return () => window.removeEventListener("click", close);
//   }, []);

//   return (
//     <div className={`text-center px-3 ${bg}`}>
//       {data.map((item, index) => (
//         <div key={index} className="py-4 border-b border-dotted border-slate-300">

//           <div className={`font-bold ${text}`}>
//             ₹{item.price}
//           </div>

//           <div className={`font-bold text-emerald-600 text-xs `}>
//             {item.sublabel}
//           </div>

//           <div className="flex items-center justify-center gap-1 mt-1 text-xs text-slate-600">
//             <span>{item.name}</span>

//             {/* ICON WRAPPER */}
//             <div className="relative">
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setActiveIndex(activeIndex === index ? null : index);
//                 }}
//               >
//                 <Info size={14} className="text-slate-400 hover:text-slate-600" />
//               </button>

//               {/* TOOLTIP */}
//               {activeIndex === index && (
//                 <div className="absolute top-full left-1/2 -translate-x-1/2 mb-2 z-30">
//                   <div className="absolute left-1/2 -translate-x-1/2 bottom-full w-3 h-3 bg-white border-l border-b border-slate-200 rotate-45 mt-3"></div>
//                   <div className="relative bg-white border border-slate-200 shadow-xl rounded-lg p-3 w-56 text-xs text-slate-600">
//                     {item.desc}
                    
//                   </div>
//                 </div>
//               )}
//             </div>

//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

// /* ================= MOBILE SECTION ================= */

// function MobileSection({ title, color, first, second }) {
//   const [active, setActive] = useState(null);

//   const colors = {
//     blue: { bg: "bg-blue-100", text: "text-blue-700" },
//     violet: { bg: "bg-violet-100", text: "text-violet-700" },
//     amber: { bg: "bg-amber-100", text: "text-amber-700" },
//   };

//   return (
//     <div className="mb-4">
//       <div className={`text-sm font-semibold mb-2 ${colors[color].text}`}>
//         {title}
//       </div>

//       {[first, second].map((item, index) => (
//         <div key={index} className="relative mb-3">

//           <div className={`flex justify-between p-3 rounded-xl ${colors[color].bg}`}>
//             <div>
//               <div className="text-xs text-slate-500">
//                 {index === 0 ? "545 Days" : "730 Days"}
//               </div>

//               <div className="text-sm font-medium text-slate-700 flex items-center gap-1">
//                 {item.name}

//                 <div className="relative">
//                   <button onClick={() => setActive(active === index ? null : index)}>
//                     <Info size={14} className="text-slate-400" />
//                   </button>

//                   {active === index && (
//                     <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-30">
//                       <div className="absolute left-1/2 -translate-x-1/2 top-full w-3 h-3 bg-white border-l border-b rotate-45"></div>
//                       <div className="relative bg-white border shadow-lg rounded-lg p-3 w-56 text-xs text-slate-600">
//                         {item.desc}
                        
//                       </div>
//                     </div>
//                   )}
//                 </div>

//               </div>
//             </div>

//             <span className={`font-bold ${colors[color].text}`}>
//               ₹{item.price}
//             </span>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }


// export default function ModelPriceList() {
//   const models = [
//     {
//       model: "Vivo V50",
//       devicePrice: 45000,
//       screen1: 500,
//       screen2: 1000,
//       totalProtection: 1800,
//       extended: 1200,
//     },
//     {
//       model: "Samsung A54",
//       devicePrice: 38000,
//       screen1: 450,
//       screen2: 900,
//       totalProtection: 1600,
//       extended: 1100,
//     },
//     {
//       model: "iQOO Neo 7",
//       devicePrice: 32000,
//       screen1: 400,
//       screen2: 800,
//       totalProtection: 1500,
//       extended: 1000,
//     },
//   ];

//   return (
//     <div className="bg-white rounded-3xl shadow-2xl p-3 md:p-5">

//       {/* ================= DESKTOP VIEW ================= */}
//       <div className="hidden md:block">

//         {/* ===== MAIN GROUP HEADER ===== */}
//         <div className="grid grid-cols-5 text-sm font-semibold">

//           <div className="px-6 py-6 bg-slate-50 text-slate-700 rounded-tl-2xl">
//             Models
//           </div>

//           <div className="col-span-2 px-6 py-6 bg-blue-100 text-blue-700 text-center">
//             Screen Damage
//           </div>

//           <div className="px-6 py-6 bg-violet-100 text-violet-700 text-center">
//             Total Protection
//           </div>

//           <div className="px-6 py-6 bg-amber-100 text-amber-700 text-center rounded-tr-2xl">
//             Extended Warranty
//           </div>
//         </div>

//         <div className="grid grid-cols-5 pt-2">

//           {/* LEFT COLUMN */}
//           <div>
//             <div className="h-7"></div>
//             {models.map((item, index) => (
//               <div
//                 key={index}
//                 className="py-2 border-b border-dotted border-slate-300"
//               >
//                 <div className="font-semibold text-slate-800">
//                   {item.model}
//                 </div>
//                 <div className="text-xs text-slate-500 mt-1">
//                   Device Price ₹{item.devicePrice.toLocaleString()}
//                 </div>
//               </div>
//             ))}
//           </div>

//           <PlanColumn
//             title="1 Time Screen"
//             color="emerald"
//             data={models.map(m => ({
//               price: m.screen1,
//               subtitle: "1 Claim"
//             }))}
//           />

//           <PlanColumn
//             title="2 Time Screen"
//             color="blue"
//             data={models.map(m => ({
//               price: m.screen2,
//               subtitle: "2 Claims"
//             }))}
//           />

//           <PlanColumn
//             title="Up To Device Price"
//             color="violet"
//             data={models.map(m => ({
//               price: m.totalProtection,
//               subtitle: "Up to Device Value"
//             }))}
//           />

//           <PlanColumn
//             title="100% Coverage"
//             color="amber"
//             data={models.map(m => ({
//               price: m.extended,
//               subtitle: "100% Coverage"
//             }))}
//           />

//         </div>
//       </div>

//       {/* ================= MOBILE VIEW ================= */}

//       <div className="md:hidden space-y-6">

//         {models.map((item, index) => (
//           <div
//             key={index}
//             className="bg-white rounded-3xl shadow-lg border border-slate-100 p-3"
//           >
//             {/* Model Header */}
//             <div className="mb-3">
//               <div className="font-semibold text-xl text-slate-800">
//                 {item.model}
//               </div>
//               <div className="text-sm text-slate-500 mt-1">
//                 Device Price ₹{item.devicePrice.toLocaleString()}
//               </div>
//             </div>

//             {/* Pricing Cards */}
//             <div className="space-y-3">

//               <MobilePlanCard
//                 label="1 Time Screen"
//                 value={item.screen1}
//                 color="emerald"
//                 subtitle="1 Claim"
//               />

//               <MobilePlanCard
//                 label="2 Time Screen"
//                 value={item.screen2}
//                 color="blue"
//                 subtitle="2 Claims"
//               />

//               <MobilePlanCard
//                 label="Total Protection"
//                 value={item.totalProtection}
//                 color="violet"
//                 subtitle="Up to Device Value"
//               />

//               <MobilePlanCard
//                 label="Extended Warranty"
//                 value={item.extended}
//                 color="amber"
//                 subtitle="100% Coverage"
//               />

//             </div>
//           </div>
//         ))}

//       </div>
//     </div>
//   );
// }

// function MobilePlanCard({ label, value, subtitle, color }) {

//   const colors = {
//     emerald: {
//       bg: "bg-emerald-50",
//       text: "text-emerald-600",
//     },
//     blue: {
//       bg: "bg-blue-100",
//       text: "text-blue-700",
//     },
//     violet: {
//       bg: "bg-violet-100",
//       text: "text-violet-700",
//     },
//     amber: {
//       bg: "bg-amber-100",
//       text: "text-amber-700",
//     }
//   };

//   return (
//     <div className={`rounded-2xl p-3 ${colors[color].bg} flex justify-between items-center`}>
      
//       <div>
//         <div className="text-sm font-medium text-slate-700">
//           {label}
//         </div>
//         <div className="text-xs text-slate-500 mt-1">
//           {subtitle}
//         </div>
//       </div>

//       <div className={`text-lg font-bold ${colors[color].text}`}>
//         ₹{value}
//       </div>

//     </div>
//   );
// }

// function PlanColumn({ title, color, data }) {

//   const colors = {
//     emerald: {
//       text: "text-emerald-600",
//       border: "border-emerald-500",
//       bg: "bg-emerald-50",
//     },
//     blue: {
//       text: "text-blue-700",
//       border: "border-blue-500",
//       bg: "bg-blue-100",
//     },
//     violet: {
//       text: "text-violet-700",
//       border: "border-violet-500",
//       bg: "bg-violet-100",
//     },
//     amber: {
//       text: "text-amber-700",
//       border: "border-amber-500",
//       bg: "bg-amber-100",
//     },
//   };

//   return (
//     <div className={`text-center px-6 ${colors[color].bg}`}>

//       <div className="flex justify-center -mt-6">
//         <div className={`px-6 py-2 rounded-full border-2 bg-white font-semibold text-sm ${colors[color].border} ${colors[color].text}`}>
//           {title}
//         </div>
//       </div>

//       {data.map((item, index) => (
//         <div
//           key={index}
//           className="py-2 border-b border-dotted border-slate-300"
//         >
//           <div className={`font-bold text-lg ${colors[color].text}`}>
//             ₹{item.price}
//           </div>
//           <div className="text-xs text-slate-500 mt-1">
//             {item.subtitle}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

// function MobileRow({ label, value }) {
//   return (
//     <div className="flex justify-between py-2 border-b border-slate-100 last:border-none">
//       <span className="text-slate-600 text-sm">{label}</span>
//       <span className="font-semibold text-blue-700">
//         ₹{value}
//       </span>
//     </div>
//   );
// }